<div class="rfq-multi-hedge" [ngClass]="{ internal: true }">
  <div class="rfq-multi-hedge-label-wrapper">
    <div class="rfq-multi-hedge-add"></div>
    <div class="rfq-multi-hedge-label">{{ groupName }} Hedges</div>
  </div>
  <div class="rfq-multi-hedge-formlabels-wrapper">
    <div class="rfq-multi-hedge-formlabels">
      <div>Type</div>
      <div>Amount</div>
      <div>Direction (offer)</div>
      <div>Direction (bid)</div>
      <div>Hedge Rate</div>
      <div>Settlement Date</div>
      <div *ngIf="showExpiryDate">Expiry Date</div>
      <div *ngIf="hedgeMode === 'DX'">Implied Spot</div>
    </div>
  </div>
  <app-provider-multi-hedge
    [hedgeMode]="hedgeMode"
    *ngFor="let hedge of setupForm.get('hedges')['controls']; let i = index"
    [form]="hedge"
    [volBased]="volBased"
    [isCustomHedge]="isCustomHedge"
    [showExpiryDate]="showExpiryDate"
    [cross]="cross"
    (fieldBlur)="onElemBlur()"
  ></app-provider-multi-hedge>
</div>
